module.exports = __webpack_public_path__ + "img/cat.750fdcfe.svg";